<div class="header">
  <div class="header__title">
    <div>
      <h1>{{title}}</h1>
      @if (subtitle) {
        <p class="header__subtitle">{{subtitle}}</p>
      }
    </div>
    @if (tooltipText) {
      <app-hint-icon [tooltipText]="tooltipText"></app-hint-icon>
    }
  </div>
  <div class="header__actions">
    <ng-content></ng-content>
  </div>
</div>

<nz-divider></nz-divider>
